import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { C, font } from "../tokens";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { applySeo } from "../lib/seo";
import { features, featureCategories } from "../data/features";

function FeatureCard({ f }) {
  const [hover, setHover] = useState(false);
  const to = f.ownPage ? `/funcionalidades/${f.slug}` : f.externalTo;
  return (
    <Link
      to={to}
      onMouseEnter={() => setHover(true)}
      onMouseLeave={() => setHover(false)}
      style={{
        display: "flex",
        flexDirection: "column",
        background: C.surface,
        border: `1px solid ${C.border}`,
        borderRadius: 18,
        padding: "24px 24px 22px",
        textDecoration: "none",
        color: C.text,
        boxShadow: hover
          ? "0 20px 44px rgba(10,15,30,0.12)"
          : "0 6px 20px rgba(10,15,30,0.05)",
        transform: hover ? "translateY(-4px)" : "translateY(0)",
        transition: "transform 0.25s cubic-bezier(.16,1,.3,1), box-shadow 0.25s",
        height: "100%",
      }}
    >
      <span
        style={{
          width: 48,
          height: 48,
          borderRadius: 13,
          flexShrink: 0,
          background: f.bg,
          color: "#fff",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          boxShadow: `0 10px 22px ${f.color}3D`,
          marginBottom: 16,
        }}
      >
        {f.icon}
      </span>
      <h3 style={{ fontFamily: font, fontSize: 18, fontWeight: 800, letterSpacing: -0.4, lineHeight: 1.2, margin: "0 0 8px", color: C.text }}>
        {f.name}
      </h3>
      <p style={{ fontFamily: font, fontSize: 14, lineHeight: 1.55, color: C.muted, margin: "0 0 16px" }}>
        {f.tagline}
      </p>
      <span style={{ marginTop: "auto", fontFamily: font, fontSize: 13, fontWeight: 800, color: f.color }}>
        {f.ownPage ? "Conhecer" : "Ver página"} →
      </span>
    </Link>
  );
}

export default function Funcionalidades() {
  useEffect(() => {
    applySeo({
      title: "Funcionalidades do IMOBMEET: tudo o que o CRM faz | IMOBMEET",
      description:
        "Conheça as funcionalidades do IMOBMEET: gestão de leads, unidades, reservas, propostas, contratos, assinatura digital, recebíveis, WhatsApp e IA.",
      keywords:
        "funcionalidades crm imobiliário, recursos crm imobiliário, gestão de leads, gestão de unidades, assinatura digital, split de comissões",
      path: "/funcionalidades",
    });
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />

      {/* Hero */}
      <section
        style={{
          position: "relative",
          overflow: "hidden",
          background: "linear-gradient(135deg, #0B1733 0%, #0A1230 100%)",
          padding: "116px 28px 56px",
        }}
      >
        <div className="grid-bg" style={{ position: "absolute", inset: 0, opacity: 0.25, pointerEvents: "none" }} />
        <div
          style={{
            position: "absolute",
            top: -80,
            right: -60,
            width: 360,
            height: 360,
            borderRadius: "50%",
            background: "radial-gradient(circle, rgba(5,96,255,0.30), transparent 65%)",
            filter: "blur(20px)",
            pointerEvents: "none",
          }}
        />
        <div style={{ maxWidth: 1180, margin: "0 auto", position: "relative" }}>
          <div style={{ fontFamily: font, fontSize: 12.5, fontWeight: 800, letterSpacing: 1.4, textTransform: "uppercase", color: "#8FB3E6", marginBottom: 14 }}>
            Funcionalidades
          </div>
          <h1 style={{ fontFamily: font, fontSize: "clamp(32px, 5vw, 50px)", fontWeight: 800, lineHeight: 1.05, letterSpacing: -1.4, color: "#fff", margin: "0 0 16px", maxWidth: 820 }}>
            Tudo o que sua operação precisa, em uma plataforma só
          </h1>
          <p style={{ fontFamily: font, fontSize: 17, lineHeight: 1.6, color: "rgba(255,255,255,0.78)", margin: 0, maxWidth: 640 }}>
            Do primeiro lead ao contrato assinado e ao recebível pago: conheça as
            funcionalidades do IMOBMEET, o CRM imobiliário all-in-one.
          </p>
        </div>
      </section>

      {/* Cards por categoria */}
      <section style={{ background: C.bgAlt, padding: "56px 28px 88px" }}>
        <div style={{ maxWidth: 1180, margin: "0 auto" }}>
          {featureCategories.map((cat) => {
            const list = features.filter((f) => f.category === cat);
            if (!list.length) return null;
            return (
              <div key={cat} style={{ marginBottom: 48 }}>
                <h2 style={{ fontFamily: font, fontSize: 24, fontWeight: 800, letterSpacing: -0.6, color: C.text, margin: "0 0 22px" }}>
                  {cat}
                </h2>
                <div
                  style={{
                    display: "grid",
                    gridTemplateColumns: "repeat(auto-fill, minmax(280px, 1fr))",
                    gap: 20,
                  }}
                >
                  {list.map((f) => (
                    <FeatureCard key={f.slug} f={f} />
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>
      <Footer />
    </>
  );
}
